// Useful to share states between different components //

export default {

	applicationName: 'app-boilerplate',
	views: [],
	transitions: [],
	has3DAssets: null,
	time: { value: 0 },
	mouse: { value: { x: 0, y: 0 } },
	destinationUrl: null,
	loaded: false,
	currentNamespace: null

}
